import { defineStore } from "pinia"

export const useUserinfo = defineStore('count', {
    // defineStore(id(一个储存库标识))
    state: () => ({
        //当前用户状态 0未登录 -1已登录
        memberStatus: 0,
        //上一次登录时间
        lastLoginDate: null,
        //上一次上线时间
        lastOnlineDate: null,
        // id: "76633",
        id: null,
        acccompanycode: null,
        // addinfo2: "1631596494621450240",
        addinfo2: null,
        addinfo3: null,
        addinfo6: null,
        addinfo7: null,
        companyId: null,
        companycode: null,
        companyname: null,
        companyname2: null,
        wa: null,
        siojournal: null,
        ctgliab: null,
        email: null,
        login: null,
        password: null,
        memmale: null,
        name: null,
        telephone: null,
        //用户账户所在的国家
        country: null,
        token: null,
        //角色性別 0男性 1女性
        modelSex: null,
        //x位置記錄
        positionX: null,
        //z位置記錄
        positionZ: null,
        //区域号码记录
        currPage: 1,
        //是否開啟聲音
        openSound: true,
        //進行了幾次新手指引
        guideCount: 0,
        //邀请商家的门牌号
        doorNumStr: null,
        //目前使用的邀請碼
        invCode: null,
        //人稱鏡頭
        CameraPerspective: "1",
        //店员性别
        shopmanSex: null,
        //商家id
        businessId: null,
        //商家Login
        businessLogin: null,
        //商家密碼
        businessPassword: null,
        //是否来自eshopopee
        fromEshopopee: null,
        //用户选择的国家
        selectCountry: null,
        //用户选择的国家名字中文
        selectCountryName: null,
        //用户选择的国家名字英文
        selectCountryName2: null,
        //頁面語言
        lang: "zh",
        //展馆id
        hid: null,
        //展馆楼层
        fid: null,
        //展馆x坐标
        hallPositionX: null,
        //展馆z坐标
        hallPositionZ: null,
        //移動速度
        speed: 0.24,
        //镜头旋转方向
        rotationNum: null,
        //Y轴镜头旋转方向
        rotationNumY: null,
        //店鋪控制室使用的companycode
        selectCompanycode: null,
        //演示展館場景
        demo_stage: null,
        //島嶼id
        islandID: null,
        //島嶼區域
        areacode: null,
        //開啟虛擬人
        vp: true,
        address: null,
        airShipAdvTimer:"",
    }),
    persist: true,
})